import { Component, OnInit} from '@angular/core';
import { SeoService } from '@services/seo.service';

@Component({
    selector: 'app-was-ist-spieloguide',
    templateUrl: './was-ist-spieloguide.component.html',
    styleUrls: ['./was-ist-spieloguide.component.scss']
})

export class WasIstSpieloguideComponent implements OnInit {

    constructor(
        private seoService: SeoService,
    ) { }

    ngOnInit() {
        this.seoService.set({
            title: 'Was ist Spieloguide? | Spieloguide',
            description: 'Erfahre, was Spieloguide ist und wie es dir hilft, Spielhallen, Wettbüros und Automatenaufstellplätze zu finden.',
            path: '/was-ist-spieloguide'
        });
    }
}
